import {
  isWwsWeddingWebsiteV2,
  type WeddingWebsiteQuery,
  type Wws_CoverPhotoItem,
  type Wws_Page,
} from '../types/graphql';

function useThemeCoupleOverride(
  useThemeCouple: boolean,
  data: WeddingWebsiteQuery | undefined,
  themeOverride?: string | string[] | undefined
): WeddingWebsiteQuery | undefined {
  // If we don't want to use the theme couple information, return the data as is.
  if (!useThemeCouple || typeof data === 'undefined') {
    return data;
  }

  let theme;

  if (typeof themeOverride === 'string' && themeOverride !== '') {
    theme = JSON.parse(themeOverride);
  } else if (
    data &&
    data.weddingWebsiteResult &&
    data.weddingWebsiteResult.theme &&
    Array.isArray(data.weddingWebsiteResult.theme.themeStyles) &&
    typeof data.weddingWebsiteResult.theme.themeStyles[0] !== 'undefined'
  ) {
    theme = data.weddingWebsiteResult.theme.themeStyles[0].styles;
  }

  // If this theme doesn't have any couple info configured, return the data as is.
  if (!theme?.config?.coupleInfo) {
    return data;
  }

  const { coupleInfo } = theme.config;

  // coverPhotoId and weddingDate will override properties on the pages, and wedding respectively.
  // info will override properties on the weddingWebsiteResult
  const { coverPhotoId, weddingDate, ...info } = coupleInfo;

  const { weddingWebsiteResult, wedding, ...rest } = data;

  if (weddingWebsiteResult?.__typename === 'WWS_WeddingWebsiteV2') {
    const { coverPhoto } = weddingWebsiteResult;

    const newCoverPhoto = coverPhotoId
      ? {
          __typename: 'WWS_CoverPhoto',
          path: `//www.theknot.com/tk-media/images/${coverPhotoId}`,
        }
      : undefined;

    const result: WeddingWebsiteQuery = {
      weddingWebsiteResult: {
        ...weddingWebsiteResult,
        ...info,
        coverPhoto: newCoverPhoto || coverPhoto,
        // Override the cover photo item if one is supplied by the theme
        pages: coverPhotoId
          ? weddingWebsiteResult.pages?.map((page: Wws_Page): Wws_Page => {
              if (page.type === 'LiteSitePage') {
                // TODO: Not sure if it is ok to set default width/height and which mediaApiId to set
                // @ts-expect-error they are doing something here, see above
                const coverPhotoItem: Wws_CoverPhotoItem = {
                  id: 1,
                  mediaUrl: `https://www.theknot.com/tk-media/images/${coverPhotoId}?ordering=explicit`,
                  rank: 1,
                  type: 'CoverPhotoItem',
                  // height: 0,
                  // mediaApiId: '',
                  // width: 0,
                };

                return {
                  ...page,
                  items: [coverPhotoItem],
                };
              }

              return page;
            })
          : weddingWebsiteResult.pages,
      },
      ...rest,
    };

    if (
      isWwsWeddingWebsiteV2(result.weddingWebsiteResult) &&
      typeof wedding !== 'undefined' &&
      wedding !== null
    ) {
      // result has read only properties so create a new override object to send back
      const resultOverride = JSON.parse(JSON.stringify(result)) || {};

      resultOverride.wedding = JSON.parse(JSON.stringify(wedding));
      resultOverride.weddingDatePreferences =
        resultOverride.weddingDatePreferences || {};

      // Override wedding date with that supplied by the theme if it exists
      if (weddingDate) {
        resultOverride.wedding.weddingDate = weddingDate;
        resultOverride.weddingDatePreferences.weddingDate = weddingDate;
      }

      return resultOverride;
    }

    return result;
  }

  return;
}

export default useThemeCoupleOverride;
